import { SecurityUserLoginModel } from 'src/app/model/security/security-user.login';

export const adminUserIS: SecurityUserLoginModel = {
  fullName: '',
  options: [],
  username: '',
  roles: {},
  authorities: [],
  accountNonExpired: false,
  accountNonLocked: false,
  credentialsNonExpired: false,
  enabled: false,
  temporal: true,
  onlyAccount: true,
};
